import SearchBar from '../SearchBar/SearchBar.vue';
import * as ue from '../../lib/util';

export default {
  install(Vue){
    Vue.prototype.$ue = ue;
    Vue.component('search-bar', SearchBar);
  }
};




// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js